import { render, staticRenderFns } from "./RatingsList.html?vue&type=template&id=0d7ddadc&external"
import script from "./RatingsList.ts?vue&type=script&lang=ts&external"
export * from "./RatingsList.ts?vue&type=script&lang=ts&external"
import style0 from "./RatingsList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports